import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBook, FiHeart, FiArrowRight } = FiIcons;

const WelcomeScreen = ({ onStart }) => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Main Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-8"
          >
            <div className="space-y-6">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="flex items-center gap-3"
              >
                <SafeIcon icon={FiBook} className="text-3xl text-primary" />
                <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 font-serif">
                  Manuscript Readiness
                  <span className="block text-primary">Scorecard</span>
                </h1>
              </motion.div>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="text-xl text-gray-600 leading-relaxed"
              >
                This is your chance to pause, reflect, and prayerfully assess how prepared 
                your book is for refinement and release.
              </motion.p>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.8 }}
                className="text-lg text-gray-700"
              >
                You'll walk away with a score, some guidance, and renewed confidence 
                in your next step.
              </motion.p>
            </div>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.0 }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={onStart}
              className="group bg-primary hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl"
            >
              Begin Assessment
              <SafeIcon 
                icon={FiArrowRight} 
                className="text-xl group-hover:translate-x-1 transition-transform duration-300" 
              />
            </motion.button>
          </motion.div>

          {/* Right Column - Scripture & Branding */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="space-y-8"
          >
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/20">
              <div className="space-y-6">
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiHeart} className="text-2xl text-accent" />
                  <h3 className="text-xl font-semibold text-gray-900 font-serif">
                    Scripture Foundation
                  </h3>
                </div>
                
                <blockquote className="space-y-4">
                  <p className="text-lg text-gray-700 italic leading-relaxed">
                    "Let all things be done decently and in order."
                  </p>
                  <cite className="text-primary font-semibold">
                    — 1 Corinthians 14:40
                  </cite>
                </blockquote>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary to-blue-600 rounded-2xl p-8 text-white shadow-lg">
              <div className="space-y-4">
                <h3 className="text-xl font-semibold font-serif">
                  Write. Refine. Release.
                </h3>
                <p className="text-blue-100 leading-relaxed">
                  A companion tool from the workshop by Jeremy Bouma of 
                  CROSS + PEN and GospelWise Author, designed to bring clarity 
                  and confidence for faith-fueled writers.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;